const topoSort = (edges) => {
  const graph = {};
  const inDegrees = {};

  for (const [u, v] of edges) {
    graph[u] = graph[u] || [];
    graph[u].push(v);
    inDegrees[v] = (inDegrees[v] || 0) + 1;
    inDegrees[u] = inDegrees[u] || 0;
  }

  const queue = [];
  for (const node in inDegrees) {
    if (inDegrees[node] === 0) {
      queue.push(node);
    }
  }

  const sorted = [];
  while (queue.length > 0) {
    const u = queue.shift();
    sorted.push(u);

    if (graph[u]) {
      for (const v of graph[u]) {
        inDegrees[v]--;
        if (inDegrees[v] === 0) {
          queue.push(v);
        }
      }
    }
  }

  if (sorted.length !== Object.keys(inDegrees).length) {
    throw new Error('Cyclic dependency detected');
  }

  return sorted;
};

export default topoSort;
